import React, { type FC } from 'react';

export const DiscountSvgRebrand: FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.44358 11.4505L2.55469 7.56163L6.99913 3.11719H10.3325C10.6393 3.11719 10.888 3.36592 10.888 3.67274V7.00608L6.44358 11.4505ZM9.22122 5.4783C9.60475 5.4783 9.91566 5.16739 9.91566 4.78385C9.91566 4.40032 9.60475 4.08941 9.22122 4.08941C8.83769 4.08941 8.52677 4.40032 8.52677 4.78385C8.52677 5.16739 8.83769 5.4783 9.22122 5.4783Z"
                fill="#324EFC"
            />
        </svg>
    );
};
